<mat-dialog-content>
    <div class="spinner-center" *ngIf="loading">
        <mat-spinner></mat-spinner>
    </div>
    <ng-container *ngIf="!loading">
        <div class="div-row">
            <div class="title">
                <span
                    *ngIf="!data?.transferActionType || data?.transferActionType === TransferActionTypes.CreateCalendarTransfer">{{
                    'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.CREATE_CALENDAR.TITLE' | translate |
                    uppercase
                    }}</span>
                <span *ngIf="data?.transferActionType === TransferActionTypes.ViewCalendarTransfer">{{
                    'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.VIEW_CALENDAR.TITLE' | translate |
                    uppercase
                    }}</span>
                <span *ngIf="data?.transferActionType === TransferActionTypes.EditCalendarTransfer">{{
                    'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.EDIT_CALENDAR.TITLE' | translate |
                    uppercase
                    }}</span>

                <span *ngIf="udeuTransferCalendar?.name as name" class="ml5">{{name}}</span>
            </div>
            <div class="action-buttons">
                <button mat-raised-button
                    [color]="data?.transferActionType === TransferActionTypes.ViewCalendarTransfer ? 'primary' : 'warn'"
                    (click)="closeDialog()">
                    <mat-icon>close</mat-icon>
                </button>

                <button mat-raised-button color="primary"
                    *ngIf="data?.transferActionType === TransferActionTypes.EditCalendarTransfer"
                    [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.EDIT_CALENDAR.TITLE' | translate"
                    (click)="createCalendar()" [disabled]="mainFormGroup.invalid">
                    <mat-icon>save</mat-icon>
                </button>

                <button mat-raised-button color="primary"
                    *ngIf="!data?.transferActionType || data?.transferActionType === TransferActionTypes.CreateCalendarTransfer"
                    [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.CREATE_CALENDAR.TITLE' | translate"
                    (click)="createCalendar()" [disabled]="mainFormGroup.invalid">
                    <mat-icon>add_circle</mat-icon>
                </button>
            </div>
        </div>
        <mat-stepper #matStepper orientation="horizontal" [linear]="false">
            <ng-container *ngIf="udeuService.getStepsFiltered(steps) as stepsList">
                <ng-container *ngFor="let step of stepsList; let i = index">
                    <ng-container *ngIf="step.form.group as formGroup">
                        <mat-step #matStep [stepControl]="formGroup" *ngIf="!step.disabled"
                            [completed]="isCompleted(matStep)">
                            <form [formGroup]="formGroup">
                                <ng-template matStepperIcon="edit"><mat-icon>check</mat-icon></ng-template>
                                <ng-template matStepperIcon="number"><mat-icon>none</mat-icon></ng-template>
                                <ng-template matStepLabel><span [matTooltip]="step.name | translate">{{step.name |
                                        translate
                                        }}</span></ng-template>
                                <div class="formDiv">
                                    <ng-container *ngIf="step.type === StepTypes.GENERIC; else special">
                                        <ng-container *ngFor="let controlName of udeuService.getObjectKeys(formGroup)">
                                            <ng-container *ngIf="step.form.fields[controlName] as formField">
                                                <ng-container *ngIf="!formField.disabled">
                                                    <div *ngIf="formField.type === MatFormFieldType.INPUT"
                                                        [ngStyle]="formField.style ? formField.style : { width: '45%'}">
                                                        <mat-form-field class="w100">
                                                            <mat-label>{{formField.label | translate}}</mat-label>
                                                            <textarea matInput cdkTextareaAutosize
                                                                [placeholder]="formField.placeholder | translate"
                                                                [formControlName]="controlName"></textarea>
                                                        </mat-form-field>
                                                    </div>

                                                    <div *ngIf="formField.type === MatFormFieldType.INPUT_LANGUAGE"
                                                        class="input-language-div"
                                                        [ngStyle]="formField.style ? formField.style : { width: '45%'}">
                                                        <mat-form-field class="w50">
                                                            <mat-label>{{formField.placeholder | translate}}</mat-label>
                                                            <textarea matInput cdkTextareaAutosize
                                                                [formControlName]="controlName"></textarea>
                                                        </mat-form-field>

                                                        <mat-form-field class="w50">
                                                            <mat-label>{{formField.extraPlaceholder |
                                                                translate}}</mat-label>
                                                            <textarea matInput cdkTextareaAutosize
                                                                [formControlName]="formField.extraControlName"></textarea>
                                                        </mat-form-field>
                                                    </div>

                                                    <smt-search-select [useChips] = "false"
                                                        *ngIf="formField.type === MatFormFieldType.SELECT"
                                                        [ngStyle]="formField.style ? formField.style : { width: '45%'}"
                                                        [group]="formGroup" [controlName]="controlName"
                                                        [label]="formField.label"
                                                        [options]="formField.options"></smt-search-select>


                                                    <div *ngIf="formField.type === MatFormFieldType.BOOLEAN"
                                                        [ngStyle]="formField.style ? formField.style : { width: '45%'}">
                                                        <mat-button-toggle-group [formControlName]="controlName">
                                                            <mat-button-toggle color="primary" [value]="true">{{
                                                                formField.placeholder |
                                                                translate }}</mat-button-toggle>
                                                            <mat-button-toggle color="primary" [value]="false">{{
                                                                formField.extraPlaceholder | translate
                                                                }}</mat-button-toggle>
                                                        </mat-button-toggle-group>
                                                    </div>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                    <ng-template #special>
                                        <ng-container *ngIf="step.type === StepTypes.RECIPIENTS">
                                            <alden-recipients class="w100" [group]="recipientsFormGroup"
                                                [controlName]="'recipients'"
                                                [udeuRecipients]="udeuTransferCalendar?.recipients"></alden-recipients>
                                        </ng-container>
                                    </ng-template>
                                </div>
                                <div class="action-buttons" #actionDiv>
                                    <button *ngIf="i != 0" mat-raised-button matStepperPrevious color="primary">{{
                                        'ALDEN.STEPS_ACTIONS.PREVIOUS' | translate
                                        }}</button>
                                    <button *ngIf="i < stepsList.length-1" mat-raised-button matStepperNext
                                        color="primary">{{ 'ALDEN.STEPS_ACTIONS.NEXT'
                                        | translate }}</button>
                                </div>
                            </form>
                        </mat-step>
                    </ng-container>
                </ng-container>
            </ng-container>
        </mat-stepper>
    </ng-container>
</mat-dialog-content>